<template>
  <div class="FiltersPage">
    <h3>2. Barcode Selectie</h3>
    <div class="w-75 d-flex align-items-center">
      <FontAwesomeIcon :icon="['fas', 'info-circle']" class="mr-3" />
      <p class="mb-0">
        Barcodes bestaan uit 4 eigenschappen, welke hieronder zijn weergegegven. Selecteer per eigenschap de klassen welke interessant zijn. De beschikbare barcode combinaties die voortkomen uit de selectie verschijnen onder het keuze paneel. Het resultaat van de keuzes kan vervolgens ook op de kaart worden bekeken.
      </p>
    </div>
    <div class="d-flex mt-3">
      <FilterControls />
    </div>
    <b-tabs class="FiltersPage__table mr-4 mb-3" content-class="mt-3">
      <b-tab title="De resulterende barcodes" active>
        <div class="w-75 d-flex align-items-center my-3">
          <FontAwesomeIcon :icon="['fas', 'info-circle']" class="mr-3" />
          <p class="m-0">
            Hieronder staan de barcodes welke voortkomen uit de hierboven gekozen combinaties. De top 5 meest voorkomende barcodes is los weergegeven op de kaart. De rest is weergegeven als de categorie "Overige".
          </p>
        </div>

        <b-table 
          :items="includedRows" 
          :fields="fields" 
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-compare="sortByBarcodeStructure"  />

      </b-tab>
      <b-tab title="Uitgesloten barcodes">
        <div class="w-75 d-flex align-items-center my-3">
          <FontAwesomeIcon :icon="['fas', 'info-circle']" class="mr-3" />
          <p class="m-0">
            Deze barcodes voldoen op minstens 1 manier <span class="text-red">niet</span> aan de geselecteerde eigenschappen.
          </p>
        </div>

        <b-table 
          :items="excludedRows" 
          :fields="fields" 
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-compare="sortByBarcodeStructure" />

      </b-tab>
    </b-tabs>
  </div>
</template>

<script>

import FilterControls from '@/components/organisms/FilterControls'

import { mapGetters } from 'vuex'

export default {
  name: 'FiltersPage',
  data() {
    return {
      sortBy: 'Totaal',
      sortDesc: true,
    }
  },
  components: { 
    FilterControls
  },
  computed: {
    ...mapGetters('filters', [
      'getActiveNeighborhood',
      'getActiveNeighborhoodInfo',
      'getFilterInfo'
    ]),
    ...mapGetters('geodata', [
      'getActiveNeighborhoodGeoData',
      'hasActiveNeighborhoodBuildingData',
      'getPropertiesAndCountPerBarcode',
      'getVisibleBuildingBarcodes'
    ]),
    activeFilterIds() {
      return Object.values(this.getFilterInfo({ mode: null }))
        // .filter(item => item.id !== 'bouwblok' && item.id !== 'bouwblok-auto' && item.id !== 'barcode')
        .filter(item => item.component && item.enabled)
        .map(item => item.id)
    },
    fields() {
      let fields = [
        { key: 'Codering', sortable: true },
      ]
      if (this.activeFilterIds.includes('eigendom')) {
        fields.push({ key: 'eigendom', sortable: true })
      }
      if (this.activeFilterIds.includes('energielabel')) {
        fields.push({ key: 'energielabel', sortable: true })
      }
      if (this.activeFilterIds.includes('wozwaardeklasse')) {
        fields.push({ key: 'WOZ waarde', sortable: true })
      }
      if (this.activeFilterIds.includes('bouwjaarklasse')) {
        fields.push({ key: 'Bouwjaar', sortable: true })
      }
      fields.push({ key: 'Totaal', sortable: true })
      return fields      
    },
    activeNeighborhoodName() {
      return this.getActiveNeighborhoodInfo.label
    },
    includedRows() {
      return this.rows.filter(row => row.Zichtbaar === 1)
    },
    excludedRows() {
      return this.rows.filter(row => row.Zichtbaar === 0)
    },
    rows() {
      if (! this.hasActiveNeighborhoodBuildingData) {
        return []
      }

      let visibleCountPerCodering = this.getVisibleBuildingBarcodes
      let BuildingPropsPerCodering = this.getPropertiesAndCountPerBarcode
      
      return Object.keys(BuildingPropsPerCodering).map(key => {
        return {
          Codering: key,
          eigendom: BuildingPropsPerCodering[key].eigendom,
          energielabel: BuildingPropsPerCodering[key].energielabel,
          'WOZ waarde': BuildingPropsPerCodering[key].wozwaardeklasse,
          'Bouwjaar': BuildingPropsPerCodering[key].bouwjaarklasse,
          Totaal: BuildingPropsPerCodering[key].count,
          Zichtbaar: visibleCountPerCodering.includes(key) ? 1 : 0,
          Bouwjaarexact: BuildingPropsPerCodering[key].bouwjaar || 0
        }
      })
      // .sort((a, b) => {
      //   return (a.Zichtbaar === b.Zichtbaar) 
      //     ? (a.Totaal < b.Totaal ? 1 : -1)
      //     : (a.Zichtbaar < b.Zichtbaar ? 1 : -1)
      // })
    }
  },
  methods: {
    /**
     * Custom sorting for Bouwjaar
     */
    sortByBarcodeStructure(aRow, bRow, key) {

      if (key === 'Bouwjaar') {
        const a = parseInt(aRow['Bouwjaarexact'])
        const b = parseInt(bRow['Bouwjaarexact'])
        return a < b ? -1 : a > b ? 1 : 0        
      } 
      
      return false
    }
  }
}
</script>

<style lang="scss"> 
.FiltersPage {
  display: grid;
}
.FiltersPage__table {
  width: 100%;
  background: white;
  padding: 20px;

  h3 {
    margin-left: 0.75rem;
  }
}
</style>